"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2930],{

/***/ 6081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DetailPageV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9583);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2879);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3955);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8352);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1914);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9735);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9741);
/* harmony import */ var _LinkTo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6269);
/* harmony import */ var _SharePopup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1320);


















function DetailPageV2(param1) {
    var headline = param1.headline, subHeadline = param1.subHeadline, backTo = param1.backTo, accordionItems = param1.accordionItems, button = param1.button, description = param1.description, price = param1.price, title1 = param1.title, color = param1.color, images = param1.images;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var isLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__/* .useLargeQuery */ .fc)().isLarge;
    var newTitle = title1;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isSharePop = ref[0], setIsSharePop = ref[1];
    var shareButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useOutsideClick */ .O3d)({
        ref: shareButtonRef,
        handler: function() {
            return setIsSharePop(false);
        }
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isModalOpen = ref1[0], setIsModalOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0), photoIdx = ref2[0], setPhotoIdx = ref2[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Section__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        bg: "white",
        color: color,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: [
                        6,
                        4,
                        2
                    ],
                    as: "h1",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    textAlign: "center",
                    children: headline
                }),
                isLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    justify: "space-between",
                    align: "flex-start",
                    w: "100%",
                    mb: 10,
                    color: "blackAlpha.700",
                    fontSize: "small",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            flex: 1,
                            children: backTo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                align: "center",
                                w: "100%",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkTo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    activeColor: "var(--chakra-colors-blackAlpha-500)",
                                    to: backTo.link,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                        align: "center",
                                        gap: 1,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoChevronBack */ .dUf, {}),
                                            locale == "id" ? "Kembali ke Halaman ".concat(backTo.text) : "Back to ".concat(backTo.text, " Page")
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                            flex: 2,
                            w: "100%",
                            justify: "center",
                            children: subHeadline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                textAlign: "center",
                                children: subHeadline
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            flex: 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    direction: {
                        base: "column-reverse",
                        lg: "row"
                    },
                    h: "100%",
                    w: "100%",
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            flex: 6,
                            w: [
                                "full",
                                null,
                                null,
                                "33%"
                            ],
                            fontSize: "sm",
                            color: "blackAlpha.900",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                    fontSize: "3xl",
                                    letterSpacing: "widest",
                                    fontWeight: 400,
                                    mb: 2,
                                    children: title1
                                }),
                                price && (0,lodash__WEBPACK_IMPORTED_MODULE_2__.toNumber)(price) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                    mb: 2,
                                    children: [
                                        locale == "id" ? "Harga mulai" : "Start from",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_14__/* .formatRupiah */ .b7)(price)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                    mb: 3,
                                    children: description
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                    my: 10,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                                        h: "100%",
                                        variant: "dark",
                                        bg: color,
                                        borderColor: color,
                                        _hover: {
                                            bg: "white",
                                            color: color
                                        },
                                        onClick: function() {
                                            button.link(true);
                                            if (button.scroll) {
                                                window.scrollTo({
                                                    top: 300,
                                                    behavior: "smooth"
                                                });
                                            }
                                        },
                                        children: button.text
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Accordion */ .UQy, {
                                    defaultIndex: [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ],
                                    allowMultiple: true,
                                    children: accordionItems.map(function(param2, i1) {
                                        var type = param2.type, items = param2.items, title = param2.title;
                                        if (type == "share") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                            position: "relative",
                                            _focus: {},
                                            ref: shareButtonRef,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                        _focus: {},
                                                        onClick: function() {
                                                            setIsSharePop(!isSharePop);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flex: "1",
                                                            align: "center",
                                                            gap: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaShare */ .Lrt, {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                    pl: 0.5,
                                                                    fontWeight: 600,
                                                                    children: title
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                isSharePop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SharePopup__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                    isOpen: isSharePop,
                                                    onClose: function() {
                                                        return setIsSharePop(false);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                    pb: 6
                                                })
                                            ]
                                        }, i1);
                                        else if (type == "capacity") {
                                            var itemName = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_14__/* .objParserWP */ .aG)(items, "item");
                                            var itemTotal = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_14__/* .objParserWPLv2 */ .iZ)(items, "total");
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                                pt: 0,
                                                children: function(param) {
                                                    var isExpanded = param.isExpanded;
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                        flex: "1",
                                                                        align: "center",
                                                                        gap: 2,
                                                                        children: [
                                                                            !isExpanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoAddOutline */ .b0B, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoRemoveOutline */ .n2U, {}),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                                pl: 0.5,
                                                                                fontWeight: 600,
                                                                                children: title
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                                py: 6,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                                                                    display: "flex",
                                                                    flexDir: "column",
                                                                    gap: 4,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                                                                        columns: 3,
                                                                        rowGap: 3,
                                                                        children: itemName.map(function(v, i) {
                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                                flexDir: "column",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                                        children: v
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                                        fontSize: "xs",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                style: {
                                                                                                    fontSize: "var(--chakra-fontSizes-xl)"
                                                                                                },
                                                                                                children: itemTotal[i]
                                                                                            }),
                                                                                            locale == "id" ? " Kursi" : " Seats"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            }, i1);
                                        } else if (type == "download") {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                flex: "1",
                                                                align: "center",
                                                                gap: 2,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaRegFilePdf */ .B$y, {}),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                        pl: 0.5,
                                                                        fontWeight: 600,
                                                                        children: title
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                        pb: 6,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                            flexDir: "column",
                                                            gap: 4,
                                                            ml: "1.6rem",
                                                            children: items.map(function(param, i1) {
                                                                var name = param.name, item = param.item;
                                                                if (item) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                                                    isExternal: true,
                                                                    href: "http://docs.google.com/viewerng/viewer?url=".concat(item.url),
                                                                    children: name
                                                                }, i1);
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, i1);
                                        } else if (type == "list") {
                                            var newItems = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_14__/* .objParserWP */ .aG)(items, "item");
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qdk, {
                                                pt: 0,
                                                children: function(param) {
                                                    var isExpanded = param.isExpanded;
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KFZ, {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                                        flex: "1",
                                                                        align: "center",
                                                                        gap: 2,
                                                                        children: [
                                                                            !isExpanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoAddOutline */ .b0B, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoRemoveOutline */ .n2U, {}),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                                                pl: 0.5,
                                                                                fontWeight: 600,
                                                                                children: title
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk3, {
                                                                py: 6,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                                                                    display: "flex",
                                                                    flexDir: "column",
                                                                    gap: 4,
                                                                    children: newItems.map(function(v) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HCh, {
                                                                            pl: 2,
                                                                            ml: 1,
                                                                            children: v
                                                                        }, v);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            }, i1);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                            flex: 12,
                            w: [
                                "full",
                                null,
                                null,
                                "66%"
                            ],
                            h: [
                                "50vh",
                                null,
                                null,
                                "100vh"
                            ],
                            position: "relative",
                            className: "section-swiper-v2",
                            children: [
                                images && images.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .Swiper */ .tq, {
                                    centeredSlides: true,
                                    loop: images.length > 1,
                                    pagination: {
                                        clickable: true
                                    },
                                    autoplay: {
                                        delay: 8000,
                                        pauseOnMouseEnter: true,
                                        disableOnInteraction: true
                                    },
                                    modules: images.length > 1 ? [
                                        swiper__WEBPACK_IMPORTED_MODULE_10__/* .Autoplay */ .pt,
                                        swiper__WEBPACK_IMPORTED_MODULE_10__/* .Pagination */ .tl
                                    ] : [],
                                    children: images.map(function(param, i) {
                                        var url = param.url, id = param.id;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .SwiperSlide */ .o5, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                w: "100%",
                                                h: [
                                                    "50vh",
                                                    null,
                                                    null,
                                                    "100%"
                                                ],
                                                position: "relative",
                                                cursor: "pointer",
                                                onClick: function() {
                                                    setIsModalOpen(true);
                                                    setPhotoIdx(i);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    alt: "",
                                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_14__/* .convertImgHttps */ .Nu)(url),
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    priority: true,
                                                    unoptimized: true
                                                })
                                            })
                                        }, id);
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                    h: "100%",
                                    w: "100%",
                                    color: color,
                                    opacity: 0.2
                                }),
                                isModalOpen && images && images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    mainSrc: images[photoIdx].url,
                                    nextSrc: images[(photoIdx + 1) % images.length],
                                    prevSrc: images[(photoIdx + images.length - 1) % images.length],
                                    onCloseRequest: function() {
                                        return setIsModalOpen(false);
                                    },
                                    onMovePrevRequest: function() {
                                        return setPhotoIdx((photoIdx + images.length - 1) % images.length);
                                    },
                                    onMoveNextRequest: function() {
                                        return setPhotoIdx((photoIdx + 1) % images.length);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 7080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormMeeting; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2175);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4853);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9583);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(155);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7333);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7258);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7239);
/* harmony import */ var _utils_const__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3026);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9741);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9735);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw1, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw1);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _throw(e) {
    throw e;
}

















function FormMeeting(param1) {
    var button = param1.button, hotel = param1.hotel, color = param1.color, type = param1.type, emailParticipants = param1.emailParticipants, headline = param1.headline, contactWa = param1.contactWa;
    var ref7 = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), push = ref7.push, reload = ref7.reload, locale = ref7.locale;
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useFormik */ .TA)({
        initialValues: {
            title: "mr",
            name: "",
            email: "",
            phone: "",
            name_of_event: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.capitalize)(type),
            date_start: "",
            date_end: "",
            total_pax: "",
            time_start: "",
            time_end: "",
            // package: "",
            setup_option: "",
            range_budget: "",
            special_request: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_11__/* .object */ .Ry({
            title: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            name: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            email: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().email(locale == "id" ? "Email tidak valid" : "Please enter a valid email").required(locale == "id" ? "Harus diisi" : "Required"),
            phone: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().matches(_utils_const__WEBPACK_IMPORTED_MODULE_14__/* .phoneRegExp */ .Oj, locale == "id" ? "Nomor telepon tidak valid" : "Phone must be a valid phone number").required(locale == "id" ? "Harus diisi" : "Required"),
            name_of_event: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_(),
            date_start: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            date_end: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            total_pax: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            time_start: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_(),
            time_end: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_(),
            // package: Yup.string().required(locale == "id" ? "Harus diisi" : "Required"),
            setup_option: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_(),
            range_budget: type == "Social Events" ? yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_() : yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            special_request: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_()
        }),
        onSubmit: function(_$param, param) {
            var _$param = _$param !== null ? _$param : _throw(new TypeError("Cannot destructure undefined")), setSubmitting = param.setSubmitting, setStatus = param.setStatus;
        }
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), selectedSetup = ref1[0], setSelectedSetup = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), checkbox = ref2[0], setCheckbox = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), capKey = ref3[0], setCapKey = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isCapValid = ref4[0], setIsCapValid = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postCapthca */ .ay)({
            response: capKey
        }).then(function(res) {
            res.data.success == true ? setIsCapValid(true) : setIsCapValid(false);
        });
    }, [
        capKey
    ]);
    function handleClick() {
        return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
        _handleClick = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
            var _values, date_end, date_start, email, name, name_of_event, phone, range_budget, setup_option, special_request, time_end, time_start, title, total_pax;
            return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        if (formik.isValid) {
                            _ctx1.next = 2;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 2:
                        if (checkbox) {
                            _ctx1.next = 4;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 4:
                        if (isCapValid) {
                            _ctx1.next = 6;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 6:
                        //here
                        formik.setSubmitting(true);
                        _values = formik.values, date_end = _values.date_end, date_start = _values.date_start, email = _values.email, name = _values.name, name_of_event = _values.name_of_event, phone = _values.phone, range_budget = _values.range_budget, setup_option = _values.setup_option, special_request = _values.special_request, time_end = _values.time_end, time_start = _values.time_start, title = _values.title, total_pax = _values.total_pax;
                        _ctx1.t0 = type == "Venue" || type == "Social Events" || type == "Meeting Package";
                        if (!_ctx1.t0) {
                            _ctx1.next = 12;
                            break;
                        }
                        _ctx1.next = 12;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postMeetingEnquiry */ .$8)({
                            date_end: date_end,
                            date_start: date_start,
                            email: email,
                            name: name,
                            name_of_event: name_of_event,
                            phone: phone,
                            range_budget: range_budget,
                            setup_option: setup_option,
                            special_request: special_request,
                            time_end: time_end,
                            time_start: time_start,
                            title: title,
                            type: type,
                            total_pax: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(total_pax),
                            hotel: hotel
                        }).then(function() {
                            var _ref1 = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res1) {
                                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx2) {
                                    while(1)switch(_ctx2.prev = _ctx2.next){
                                        case 0:
                                            if (!(res1.status == 200)) {
                                                _ctx2.next = 3;
                                                break;
                                            }
                                            _ctx2.next = 3;
                                            return (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postSendMail */ .ZC)({
                                                mailkey: "halo",
                                                emails: email,
                                                subject: "Your ".concat(type, " Enquiry Request"),
                                                title: "Your ".concat(type, " Enquiry Request"),
                                                hotel: hotel,
                                                name: name,
                                                body: "Just to let you know \u2014 we've received your ".concat(type, " Enquiry Request, and it is now being processed."),
                                                type: type
                                            }).then(function() {
                                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res2) {
                                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                if (!(res2.status == 200)) {
                                                                    _ctx.next = 3;
                                                                    break;
                                                                }
                                                                _ctx.next = 3;
                                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postSendMail */ .ZC)({
                                                                    mailkey: "halo",
                                                                    emails: emailParticipants,
                                                                    subject: "Your ".concat(type, " Enquiry Request"),
                                                                    title: "Your ".concat(type, " Enquiry Request"),
                                                                    hotel: hotel,
                                                                    name: "Admins",
                                                                    body: "<div>\n                <h3>\n                  A ".concat(type, ' Enquiry Request from a Customer!\n                </h3>\n                <table class="detail-table">\n                  <tr>\n                    <td>Hotel</td>\n                    <td> : </td>\n                    <td>').concat(hotel, "</td>\n                  </tr>\n                  <tr>\n                    <td>Name</td>\n                    <td> : </td>\n                    <td>").concat(name, "</td>\n                  </tr>\n                  <tr>\n                    <td>Email</td>\n                    <td> : </td>\n                    <td>").concat(email, "</td>\n                  </tr>\n                  <tr>\n                    <td>Phone</td>\n                    <td> : </td>\n                    <td>").concat(phone, "</td>\n                  </tr>\n                  <tr>\n                    <td>Start Date</td>\n                    <td> : </td>\n                    <td>").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getFormattedDateValue */ .ww)(date_start), "</td>\n                  </tr>\n                  <tr>\n                    <td>End Date</td>\n                    <td> : </td>\n                    <td>").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getFormattedDateValue */ .ww)(date_end), "</td>\n                  </tr>\n                  <tr>\n                    <td>Pax</td>\n                    <td> : </td>\n                    <td>").concat(total_pax, "</td>\n                  </tr>\n                  <tr>\n                    <td>Budget</td>\n                    <td> : </td>\n                    <td>").concat(range_budget, "</td>\n                  </tr>\n                  <tr>\n                    <td>Special Request</td>\n                    <td> : </td>\n                    <td>").concat(special_request !== null && special_request !== void 0 ? special_request : "-", "</td>\n                  </tr>\n                </table>\n              </div>"),
                                                                    type: type
                                                                }).then(function(res) {
                                                                    res.status == 200 && formik.setStatus("success");
                                                                });
                                                            case 3:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                }));
                                                return function(res2) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }());
                                        case 3:
                                        case "end":
                                            return _ctx2.stop();
                                    }
                                }, _callee2);
                            }));
                            return function(res1) {
                                return _ref1.apply(this, arguments);
                            };
                        }());
                    case 12:
                        _ctx1.t1 = type == "wedding";
                        if (!_ctx1.t1) {
                            _ctx1.next = 16;
                            break;
                        }
                        _ctx1.next = 16;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postWeddingEnquiry */ .AQ)({
                            date_end: date_end,
                            date_start: date_start,
                            email: email,
                            name: name,
                            name_of_event: name_of_event,
                            phone: phone,
                            range_budget: range_budget,
                            special_request: special_request,
                            time_end: time_end,
                            time_start: time_start,
                            title: title,
                            total_pax: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(total_pax),
                            hotel: hotel
                        }).then(function() {
                            var _ref2 = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(res3) {
                                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx3) {
                                    while(1)switch(_ctx3.prev = _ctx3.next){
                                        case 0:
                                            if (!(res3.status == 200)) {
                                                _ctx3.next = 3;
                                                break;
                                            }
                                            _ctx3.next = 3;
                                            return (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postSendMail */ .ZC)({
                                                mailkey: "halo",
                                                emails: email,
                                                subject: "Your ".concat(type, " Enquiry Request"),
                                                title: "Your ".concat(type, " Enquiry Request"),
                                                hotel: hotel,
                                                name: name,
                                                body: "Just to let you know \u2014 we've received your ".concat(type, " Enquiry Request, and it is now being processed."),
                                                type: type
                                            }).then(function() {
                                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res4) {
                                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                if (!(res4.status == 200)) {
                                                                    _ctx.next = 3;
                                                                    break;
                                                                }
                                                                _ctx.next = 3;
                                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_13__/* .postSendMail */ .ZC)({
                                                                    mailkey: "halo",
                                                                    emails: emailParticipants,
                                                                    subject: "Your ".concat(type, " Enquiry Request"),
                                                                    title: "Your ".concat(type, " Enquiry Request"),
                                                                    hotel: hotel,
                                                                    name: "Admins",
                                                                    body: '<div>\n                  <h3>\n                    A Wedding Enquiry Request from a Customer!\n                  </h3>\n                  <table class="detail-table">\n                    <tr>\n                      <td>Hotel</td>\n                      <td> : </td>\n                      <td>'.concat(hotel, "</td>\n                    </tr>\n                    <tr>\n                      <td>Name</td>\n                      <td> : </td>\n                      <td>").concat(name, "</td>\n                    </tr>\n                    <tr>\n                      <td>Email</td>\n                      <td> : </td>\n                      <td>").concat(email, "</td>\n                    </tr>\n                    <tr>\n                      <td>Phone</td>\n                      <td> : </td>\n                      <td>").concat(phone, "</td>\n                    </tr>\n                    <tr>\n                      <td>Start Date</td>\n                      <td> : </td>\n                      <td>").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getFormattedDateValue */ .ww)(date_start), "</td>\n                    </tr>\n                    <tr>\n                      <td>End Date</td>\n                      <td> : </td>\n                      <td>").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getFormattedDateValue */ .ww)(date_end), "</td>\n                    </tr>\n                    <tr>\n                      <td>Pax</td>\n                      <td> : </td>\n                      <td>").concat(total_pax, "</td>\n                    </tr>\n                    <tr>\n                      <td>Budget</td>\n                      <td> : </td>\n                      <td>").concat(range_budget, "</td>\n                    </tr>\n                    <tr>\n                      <td>Special Request</td>\n                      <td> : </td>\n                      <td>").concat(special_request !== null && special_request !== void 0 ? special_request : "-", "</td>\n                    </tr>\n                  </table>\n                </div>"),
                                                                    type: type
                                                                }).then(function(res) {
                                                                    if (res.status == 200) {
                                                                        var ref, ref5, ref6;
                                                                        formik.setStatus("success");
                                                                        var rawWa = ((ref = res.data) === null || ref === void 0 ? void 0 : ref.kontak_wa) || ((ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.kontak_wa) || contactWa;
                                                                        var formattedWa = rawWa ? String(rawWa).replace(/[^0-9]/g, "").replace(/^0/, "62") : "";
                                                                        if (formattedWa) {
                                                                            var text = encodeURIComponent("Halo ".concat(hotel, ",\n\nSaya ingin menanyakan tentang paket pernikahan.\nBerikut detail saya:\n- Nama: ").concat(name, "\n- Email: ").concat(email, "\n- Telepon: ").concat(phone));
                                                                            window.open("https://api.whatsapp.com/send?phone=".concat(formattedWa, "&text=").concat(text), "_blank");
                                                                        } else {
                                                                            alert(locale === "id" ? "Gagal mengalihkan ke WhatsApp: Nomor kontak WhatsApp tidak ditemukan untuk hotel ini." : "Failed to redirect to WhatsApp: WhatsApp contact number not found for this hotel.");
                                                                        }
                                                                    }
                                                                });
                                                            case 3:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                }));
                                                return function(res4) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }());
                                        case 3:
                                        case "end":
                                            return _ctx3.stop();
                                    }
                                }, _callee3);
                            }));
                            return function(res3) {
                                return _ref2.apply(this, arguments);
                            };
                        }());
                    case 16:
                        formik.setSubmitting(false);
                    case 17:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return _handleClick.apply(this, arguments);
    }
    var isXLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__/* .useLargeQuery */ .fc)().isXLarge;
    var _NEXT_PUBLIC_CAPTCHA_SITE_KEY, _NEXT_PUBLIC_CAPTCHA_SITE_KEY1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
        position: "fixed",
        top: 0,
        zIndex: 5,
        bg: "blackAlpha.600",
        h: "100vh",
        w: "100vw",
        children: formik.isSubmitting || formik.status && formik.status == "success" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AbsoluteCenter */ .umj, {
            w: [
                "90vw",
                "85vw",
                "70vw",
                "60vw",
                "50vw"
            ],
            h: [
                "60vh",
                "50vh",
                "40vh"
            ],
            bg: "black",
            px: 20,
            borderColor: "white",
            borderRadius: 0,
            borderWidth: 10,
            zIndex: 6,
            children: formik.isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                w: "100%",
                h: "100%",
                gap: 10,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Spinner */ .$jN, {
                    color: "white",
                    size: "xl"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                w: "100%",
                h: "100%",
                flexDir: "column",
                gap: 10,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                        as: "h4",
                        fontWeight: 400,
                        letterSpacing: "widest",
                        fontSize: "xl",
                        color: "white",
                        textAlign: "center",
                        children: "Thank you, our representatives will contact you shortly regarding your request."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                            variant: "outline",
                            color: "white",
                            onClick: function() {
                                button(false);
                            },
                            children: locale == "id" ? "TUTUP" : "CLOSE"
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AbsoluteCenter */ .umj, {
            w: [
                "90vw",
                "85vw",
                "80vw",
                "75vw"
            ],
            h: [
                "80vh"
            ],
            mt: 10,
            overflowY: "scroll",
            bg: "white",
            px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_15__/* .safeMarginX */ .Mp,
            py: [
                6,
                8,
                12
            ],
            zIndex: 6,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                        position: "absolute",
                        top: [
                            -4,
                            0
                        ],
                        right: [
                            -2,
                            0
                        ],
                        cursor: "pointer",
                        onClick: function() {
                            button(false);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_9__/* .IoClose */ .bjh, {
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "zero",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                        mt: [
                                            5,
                                            null,
                                            null,
                                            0
                                        ],
                                        mb: 2,
                                        as: "h1",
                                        fontWeight: 400,
                                        letterSpacing: "wider",
                                        textAlign: "center",
                                        textTransform: "uppercase",
                                        children: headline
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                        mb: 3,
                                        fontSize: "sm",
                                        color: "blackAlpha.600",
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                        children: hotel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                flex: 8,
                                flexDir: "column",
                                gap: 10,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: 6,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                mb: 6,
                                                as: "h2",
                                                fontWeight: 400,
                                                letterSpacing: "wider",
                                                fontSize: "2xl",
                                                children: locale == "id" ? "INFORMASI KONTAK" : "CONTACT INFORMATION"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                gap: [
                                                    0,
                                                    0,
                                                    0,
                                                    6
                                                ],
                                                flexDir: [
                                                    "column",
                                                    null,
                                                    null,
                                                    "row"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "15%"
                                                        ],
                                                        flexDir: "column",
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "title",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Gelar*" : "Title*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                                        fontSize: "sm",
                                                                        id: "title",
                                                                        name: "title",
                                                                        borderRadius: 0,
                                                                        _focus: {},
                                                                        onChange: function(e) {
                                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                                title: e.target.value
                                                                            }));
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                                value: "mr",
                                                                                children: locale == "id" ? "Bapak" : "Mr"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                                value: "mrs",
                                                                                children: locale == "id" ? "Ibu" : "Mrs"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.title
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "35%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "name",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Nama*" : "Name*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "name",
                                                                        name: "name",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Nama Lengkap" : "Full Name",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "email",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: "Email*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "email",
                                                                        name: "email",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Email" : "Your email",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.email
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.email
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "phone",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Telepon*" : "phone*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "phone",
                                                                        name: "phone",
                                                                        type: "tel",
                                                                        borderRadius: 0,
                                                                        placeholder: "123456",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.phone
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: 6,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                mb: 6,
                                                as: "h2",
                                                fontWeight: 400,
                                                letterSpacing: "wider",
                                                fontSize: "2xl",
                                                children: locale == "id" ? "INFORMASI ACARA" : "EVENT INFORMATION"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                gap: [
                                                    0,
                                                    0,
                                                    0,
                                                    6
                                                ],
                                                mb: 6,
                                                flexDir: [
                                                    "column",
                                                    null,
                                                    null,
                                                    "row"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "50%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "name_of_event",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Nama acara" : "Name of Event"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "name_of_event",
                                                                    name: "name_of_event",
                                                                    type: "text",
                                                                    borderRadius: 0,
                                                                    placeholder: "Your Event",
                                                                    onChange: formik.handleChange,
                                                                    onBlur: formik.handleBlur,
                                                                    value: formik.values.name_of_event
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Tanggal Mulai*" : "Start Date*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        type: "date",
                                                                        min: new Date().toISOString().split("T")[0],
                                                                        borderRadius: 0,
                                                                        onChange: function(e) {
                                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                                date_start: e.target.value
                                                                            }));
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.date_start
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Tanggal Selesai*" : "End Date*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        disabled: !formik.values.date_start,
                                                                        min: new Date(new Date().setDate(new Date(formik.values.date_start == "" ? new Date() : formik.values.date_start).getDate() + 1)).toISOString().split("T")[0],
                                                                        type: "date",
                                                                        borderRadius: 0,
                                                                        onChange: function(e) {
                                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                                date_end: e.target.value
                                                                            }));
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.date_end
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                gap: 6,
                                                mb: 6,
                                                flexDir: [
                                                    "column",
                                                    null,
                                                    null,
                                                    "row"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "50%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "total_pax",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Jumlah Orang*" : "Total pax*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "total_pax",
                                                                        name: "total_pax",
                                                                        type: "number",
                                                                        borderRadius: 0,
                                                                        placeholder: "500",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.total_pax
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.total_pax
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Waktu Mulai" : "Start Time"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    type: "time",
                                                                    borderRadius: 0,
                                                                    onChange: function(e) {
                                                                        formik.setValues(_objectSpread({}, formik.values, {
                                                                            time_start: e.target.value
                                                                        }));
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Waktu Selesai" : "End Time"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    type: "time",
                                                                    borderRadius: 0,
                                                                    disabled: !formik.values.time_start,
                                                                    min: formik.values.time_start,
                                                                    onChange: function(e) {
                                                                        formik.setValues(_objectSpread({}, formik.values, {
                                                                            time_end: e.target.value
                                                                        }));
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                        children: [
                                            (type == "Venue" || type == "Meeting Package") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        mb: 6,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                            orientation: "horizontal"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                        mb: 6,
                                                        as: "h2",
                                                        fontWeight: 400,
                                                        letterSpacing: "wider",
                                                        fontSize: "2xl",
                                                        children: [
                                                            locale == "id" ? "INFORMASI TENTANG" : "INFORMATION ABOUT",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                            locale == "id" ? "RUANG RAPAT" : "MEETING ROOM"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        gap: 6,
                                                        mb: 10,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                            flexDir: "column",
                                                            w: "100%",
                                                            mb: [
                                                                3,
                                                                null,
                                                                null,
                                                                0
                                                            ],
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                    htmlFor: "name_of_event",
                                                                    fontSize: "xl",
                                                                    textTransform: "uppercase",
                                                                    fontWeight: 400,
                                                                    children: locale == "id" ? "PILIHAN SUSUNAN" : "SET-UP OPTIONS"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                    mt: 2,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .RadioGroup */ .FXm, {
                                                                        onChange: function(e) {
                                                                            setSelectedSetup((0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(e));
                                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                                setup_option: locale == "id" ? setupOptions[(0,lodash__WEBPACK_IMPORTED_MODULE_4__.toNumber)(e)].name_id : setupOptions[(0,lodash__WEBPACK_IMPORTED_MODULE_4__.toNumber)(e)].name_en
                                                                            }));
                                                                        },
                                                                        value: selectedSetup,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kqy, {
                                                                            direction: "row",
                                                                            display: "flex",
                                                                            flexWrap: "wrap",
                                                                            justifyContent: "space-between",
                                                                            w: "100%",
                                                                            children: setupOptions.map(function(param, i) {
                                                                                var name_en = param.name_en, name_id = param.name_id, icon = param.icon;
                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                                    flexDir: "column",
                                                                                    alignItems: "center",
                                                                                    color: "blackAlpha.600",
                                                                                    gap: 1,
                                                                                    mb: [
                                                                                        10,
                                                                                        8,
                                                                                        2,
                                                                                        0
                                                                                    ],
                                                                                    children: [
                                                                                        icon,
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                            as: "span",
                                                                                            fontSize: "sm",
                                                                                            mb: 2,
                                                                                            children: locale == "id" ? name_id : name_en
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Radio */ .Y8K, {
                                                                                            value: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(i)
                                                                                        })
                                                                                    ]
                                                                                }, i);
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: 6,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                gap: [
                                                    0,
                                                    0,
                                                    0,
                                                    6
                                                ],
                                                mb: 6,
                                                flexDir: [
                                                    "column",
                                                    null,
                                                    null,
                                                    "row"
                                                ],
                                                children: [
                                                    !(type == "Social Events") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "50%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "range_budget",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Anggaran*" : "Range Budget*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .InputGroup */ .BZy, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .InputLeftElement */ .Z8_, {
                                                                                pointerEvents: "none",
                                                                                color: "blackAlpha.600",
                                                                                fontSize: "sm",
                                                                                children: "Rp."
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                                className: "input-currency",
                                                                                placeholder: "60.000.000",
                                                                                isNumericString: true,
                                                                                thousandSeparator: true,
                                                                                value: formik.values.range_budget,
                                                                                onValueChange: function(vals) {
                                                                                    return formik.setValues(_objectSpread({}, formik.values, {
                                                                                        range_budget: vals.formattedValue
                                                                                    }));
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.range_budget
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Slider */ .iRW, {
                                                                        mt: 4,
                                                                        mb: 10,
                                                                        colorScheme: "blackAlpha",
                                                                        defaultValue: 60000000,
                                                                        min: 0,
                                                                        max: 1000000000,
                                                                        step: 10000000,
                                                                        onChange: function(v) {
                                                                            return formik.setValues(_objectSpread({}, formik.values, {
                                                                                range_budget: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(v)
                                                                            }));
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SliderTrack */ .Uj8, {
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SliderFilledTrack */ .MsD, {})
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SliderThumb */ .gsu, {})
                                                                        ]
                                                                    }),
                                                                    isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                        sitekey: (_NEXT_PUBLIC_CAPTCHA_SITE_KEY = "6LffTCkgAAAAAOh8Ko1Zx6016qXUseJu2gwQECFl") !== null && _NEXT_PUBLIC_CAPTCHA_SITE_KEY !== void 0 ? _NEXT_PUBLIC_CAPTCHA_SITE_KEY : "",
                                                                        onChange: function(value) {
                                                                            return setCapKey(value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "50%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Permintaan Spesial" : "Special request"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Textarea */ .gxH, {
                                                                    fontSize: "sm",
                                                                    borderRadius: 0,
                                                                    placeholder: locale == "id" ? "Permintaan Anda" : "Your Request",
                                                                    onChange: function(e) {
                                                                        formik.setValues(_objectSpread({}, formik.values, {
                                                                            special_request: e.target.value
                                                                        }));
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZJ, {
                                                                mt: 4,
                                                                mb: 6,
                                                                defaultChecked: false,
                                                                isChecked: checkbox,
                                                                onChange: function() {
                                                                    setCheckbox(!checkbox);
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    children: [
                                                                        locale == "id" ? "Saya telah membaca dan menyetujui" : "I have read and accepted the",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                            onClick: function() {
                                                                                push("/privacy-policy");
                                                                            },
                                                                            style: {
                                                                                fontWeight: 500,
                                                                                textDecoration: "underline"
                                                                            },
                                                                            children: locale == "id" ? "Privasi & Kebijakan" : "privacy policy"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            (!isXLarge || type == "Social Events") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                mb: 6,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                    sitekey: (_NEXT_PUBLIC_CAPTCHA_SITE_KEY1 = "6LffTCkgAAAAAOh8Ko1Zx6016qXUseJu2gwQECFl") !== null && _NEXT_PUBLIC_CAPTCHA_SITE_KEY1 !== void 0 ? _NEXT_PUBLIC_CAPTCHA_SITE_KEY1 : "",
                                                                    onChange: function(value) {
                                                                        return setCapKey(value);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                                    variant: "solid",
                                                                    bg: color,
                                                                    color: "white",
                                                                    px: 8,
                                                                    py: 5,
                                                                    cursor: formik.isSubmitting || !formik.isValid || formik.status == "success" ? "not-allowed" : "pointer",
                                                                    onClick: handleClick,
                                                                    disabled: formik.isSubmitting || !formik.isValid || formik.status == "success" || !checkbox || !isCapValid || (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isEmpty)(formik.values.name),
                                                                    children: locale == "id" ? "Permintaan Anggaran" : "REQUEST BUDGET"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var setupOptions = [
    {
        name_id: "Classroom",
        name_en: "Classroom",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaTh */ .uOL, {})
    },
    {
        name_id: "Cocktail",
        name_en: "Cocktail",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaSpinner */ .fCD, {})
    },
    {
        name_id: "Board Room",
        name_en: "Board Room",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaGripVertical */ .wNu, {})
    },
    {
        name_id: "Theatre",
        name_en: "Theatre",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaThLarge */ .xyo, {})
    },
    {
        name_id: "U-Shape",
        name_en: "U-Shape",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaHockeyPuck */ .pZ$, {})
    },
    {
        name_id: "Banquet",
        name_en: "Banquet",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaCircleNotch */ .koH, {})
    },
    {
        name_id: "Lainnya",
        name_en: "Others",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaEllipsisH */ .LCi, {})
    }, 
];


/***/ }),

/***/ 1320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharePopup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);






function SharePopup(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), currentUrl = ref[0], setCurrentUrl = ref[1];
    var ref1 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useClipboard */ .VPI)(currentUrl), hasCopied = ref1.hasCopied, onCopy = ref1.onCopy;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (true) {
            setCurrentUrl(window.location.href);
        }
    }, []);
    var facebookURL = "https://www.facebook.com/sharer/sharer.php?u=".concat(currentUrl);
    var whatsAppURL = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(currentUrl));
    var handleFacebookShare = function() {
        if (true) {
            window.open(facebookURL, "_blank");
        }
    };
    var handleWhatsAppShare = function() {
        if (true) {
            window.open(whatsAppURL, "_blank");
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        bg: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "9999",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            bg: "white",
            borderRadius: "md",
            p: 6,
            maxWidth: "400px",
            width: "90%",
            position: "relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                    position: "absolute",
                    top: 2,
                    right: 2,
                    onClick: onClose,
                    variant: "ghost",
                    size: "sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoClose */ .bjh, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    fontSize: "lg",
                    fontWeight: "bold",
                    mb: 4,
                    children: "Share this page"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 3,
                    mb: 4,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoFacebook */ .egd, {}),
                            colorScheme: "facebook",
                            onClick: handleFacebookShare,
                            flex: 1,
                            children: "Facebook"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoLogoWhatsapp */ .ff9, {}),
                            colorScheme: "whatsapp",
                            bg: "#25D366",
                            _hover: {
                                bg: "#128C7E"
                            },
                            onClick: handleWhatsAppShare,
                            flex: 1,
                            children: "WhatsApp"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                            value: currentUrl,
                            readOnly: true,
                            placeholder: currentUrl,
                            flex: 1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdContentCopy */ .Fqs, {}),
                            onClick: onCopy,
                            colorScheme: hasCopied ? "green" : "gray",
                            children: hasCopied ? "Copied!" : "Copy"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ })

}]);